import React from 'react';
import { AuthProvider } from '../features/auth';
import { CheckoutProvider } from '../features/checkout';
import { GachaProvider } from '../features/gacha';
import { LockerProvider } from '../features/locker';
import { ToastProvider } from '../features/toast';
import { ModalProvider } from '../features/modal/ModalContext';

const AppProviders = ({ children }) => {
  return (
    <ToastProvider>
      <AuthProvider>
        <CheckoutProvider>
          <GachaProvider>
            <LockerProvider>
              <ModalProvider>{children}</ModalProvider>
            </LockerProvider>
          </GachaProvider>
        </CheckoutProvider>
      </AuthProvider>
    </ToastProvider>
  );
};

export default AppProviders;
